import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RequestsRoutingModule } from './requests-routing.module';
import { RequestsComponent } from './pages/requests/requests.component';
import { RequestDetailComponent } from './pages/request-detail/request-detail.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CreateComponent } from './pages/create/create.component';
import { UpdateComponent } from './pages/update/update.component';

@NgModule({
  declarations: [RequestsComponent, RequestDetailComponent, CreateComponent, UpdateComponent],
  imports: [
    CommonModule,
    RequestsRoutingModule,
    SharedModule,
    FlexLayoutModule,
  ],
})
export class RequestsModule {}
